import React, { useContext } from "react";
import styled from "styled-components";
// Components
import ServiceBox from "../Elements/ServiceBox";
import FullButton from "../Buttons/FullButton";
import { Link } from "react-scroll";
// Assets
import AddImage1 from "../../assets/img/add/1.png";
import AddImage2 from "../../assets/img/add/2.png";
import AddImage3 from "../../assets/img/add/3.png";
import AddImage4 from "../../assets/img/add/4.png";
import { LanguageContext } from "../../screens/LanguageContext";  // Import the context

export default function Services() {
  const { language } = useContext(LanguageContext); // Access the language context

  // Translations based on selected language
  const translations = {
    en: {
      title: "Our Exceptional Packaging Solutions",
      description:
        "From high-quality plastic bags and eco-friendly options to advanced lamination rolls, we provide tailored packaging solutions to meet all your business needs. With cutting-edge technology and a commitment to sustainability, we ensure your products are always well-presented.",
      service1: "Plastic Bags",
      service1Desc:
        "High-quality HD-LD plastic bags available in various sizes, plain or printed with up to 6 colors, including eco-friendly biodegradable options.",
      service2: "Garbage Rolls",
      service2Desc:
        "Durable polyethylene garbage rolls in multiple sizes and colors, tailored to meet diverse customer needs.",
      service3: "Lamination Rolls",
      service3Desc:
        "Multi-layer lamination rolls, ideal for food packaging such as coffee and snacks, made with materials like BE, BET, OPP, and CPP.",
      service4: "Eco-Friendly Packaging",
      service4Desc:
        "Custom biodegradable and eco-friendly solutions for sustainable packaging, including Zipper bags for spices and snacks.",
    },
    ar: {
      title: "حلول التعبئة والتغليف الاستثنائية لدينا",
      description:
        "من أكياس البلاستيك عالية الجودة والخيارات الصديقة للبيئة إلى لفائف التغليف المتقدمة، نقدم حلول التعبئة والتغليف المخصصة لتلبية جميع احتياجات أعمالك. مع التكنولوجيا المتطورة واهتمامنا بالاستدامة، نضمن أن تكون منتجاتك دائمًا مميزة.",
      service1: "أكياس البلاستيك",
      service1Desc:
        "أكياس بلاستيك عالية الجودة HD-LD متوفرة بأحجام مختلفة، سواء سادة أو مطبوعة حتى 6 ألوان، بما في ذلك الخيارات الصديقة للبيئة القابلة للتحلل.",
      service2: "لفائف القمامة",
      service2Desc:
        "لفائف قمامة من البولي إيثيلين متينة بأحجام وألوان متعددة، مصممة لتلبية احتياجات العملاء المتنوعة.",
      service3: "لفائف التغليف المتعددة",
      service3Desc:
        "لفائف تغليف متعددة الطبقات، مثالية لتعبئة الطعام مثل القهوة والوجبات الخفيفة، مصنوعة من مواد مثل BE وBET وOPP وCPP.",
      service4: "التعبئة والتغليف الصديقة للبيئة",
      service4Desc:
        "حلول مخصصة قابلة للتحلل البيولوجي وصديقة للبيئة للتغليف المستدام، بما في ذلك الأكياس المزودة بسحّاب للبهارات والوجبات الخفيفة.",
    },
  };

  const { title, description, service1, service1Desc, service2, service2Desc, service3, service3Desc, service4, service4Desc } = translations[language];

  return (
    <Wrapper id="services">
      <div className="whiteBg" style={{ padding: "60px 0" }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">{title}</h1>
            <p className="font13">{description}</p>
          </HeaderInfo>
          <ServiceBoxRow className="flex">
            <ServiceBoxWrapper>
              <ServiceBox
                icon="bag"
                title={service1}
                subtitle={service1Desc}
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="garbage"
                title={service2}
                subtitle={service2Desc}
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="lamination"
                title={service3}
                subtitle={service3Desc}
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="eco"
                title={service4}
                subtitle={service4Desc}
              />
            </ServiceBoxWrapper>
          </ServiceBoxRow>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const ServiceBoxRow = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const ServiceBoxWrapper = styled.div`
  width: 20%;
  margin-right: 5%;
  padding: 80px 0;
  @media (max-width: 860px) {
    width: 100%;
    text-align: center;
    padding: 40px 0;
  }
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
